import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { HeaderTemplate, Stepper, TitleHeader } from 'web-library';

import { makeStyles } from 'tss-react/mui';
import NonNationalExamTypeUuidDisplay from './NonNationalExamTypeUuidDisplay';
import ConfirmParticularsAEIS from '../../../modules/examRegistration/components/nonNationalExam/ConfirmParticularsAEIS';
import ConfirmParticularsSPERS from '../../../modules/examRegistration/components/nonNationalExam/ConfirmParticularsSPERS';
import { ParentParticularsLocation } from './AEIS/ParentParticulars';
import VacancyExpiredModal from './VacancyExpiredModal';
import { useGetPassportDisabled } from '../../../api-refactored/non-national-exam-registration/useGetPassportDisabled';
import { NonNexPassportDisableContext } from '../../../routes/RootRouter';

const useStyles = makeStyles()(() => ({
  stepper: {
    position: 'relative',
    left: '-1.3%',
  },
}));

interface ConfirmParticularsPageProps {
  routeSteps: { label: string | JSX.Element; disabled?: boolean }[];
  isAEIS: boolean;
  isOpsAdmin: boolean;
}

const ConfirmParticulars = ({ routeSteps, isAEIS, isOpsAdmin }: ConfirmParticularsPageProps) => {
  const { uuid } = useParams<{ uuid: string }>();
  const { state } = useLocation<ParentParticularsLocation>();
  const { t } = useTranslation();
  const { classes } = useStyles();
  const examTitle =
    t('exam->>RegisterExam.RegisterForAnExam') +
    (state?.isSupplementary ? ` - ${t('exam->>Instructions.Supplementary')}` : '');

  const [isPassportDisabled, setIsPassportDisabled] = useState<boolean>(false);
  const nonNexPassportDisableContext = useContext(NonNexPassportDisableContext);

  useGetPassportDisabled({
    onSuccess: (res) => {
      setIsPassportDisabled(true);
      console.log(res);
      nonNexPassportDisableContext.setIsPassportDisabled(res);
    },
  });

  return (
    <>
      <TitleHeader title={isOpsAdmin ? t('exam->>NonNationalExam.ReviewApplication') : examTitle} />
      <HeaderTemplate>
        <NonNationalExamTypeUuidDisplay nonExamType={state?.examTitle || '-'} enableApi={false} />
        <Stepper className={classes.stepper} activeStep={3} steps={routeSteps} />
      </HeaderTemplate>
      {isAEIS ? (
        <ConfirmParticularsAEIS isOpsAdmin={isOpsAdmin} />
      ) : (
        <ConfirmParticularsSPERS isOpsAdmin={isOpsAdmin} />
      )}
      {!isOpsAdmin && <VacancyExpiredModal uuid={uuid} />}
    </>
  );
};

export default ConfirmParticulars;
